// extracted by mini-css-extract-plugin
export default {"newsHeader":"news_newsHeader__iWXlz","newsContent":"news_newsContent__-PqA6"};